import React, { useEffect } from 'react';
import AttendanceSheetReportDataTable from './AttendanceSheetReportDataTable';

const AttendanceSheetReportIndex = ({ rrhh }) => {
  useEffect(() => window.scrollTo(0, 0), []);
  return <AttendanceSheetReportDataTable rrhh={rrhh} />;
};

export default AttendanceSheetReportIndex;
